<template>
	<div>
		<div v-if="$route.name === 'detail-diagnoses'">
			<title-header 
				:title="diagnostic ? diagnostic.name : 'Nombre de Diagnóstico'">
				<div class="wrapper-btns">
					<v-btn color="primary btn-action" @click="goToBack">
						<img 
							src="/static/img/icons/btn-right-arrow.webp" 
							alt="Atrás"
							class="mr-4"
						/>
						Atrás
					</v-btn>
				</div>
			</title-header>
			<v-layout wrap mt-5>
				<v-flex xs6 mb-5 px-2
					v-for="tool in tools" 
					:key="tool.id"
				>
					<card-tool
						big
						:btn-rotated="false"
						:data="tool"
						:graphic="tool.tool.code === 'OCI'"
						view-applicants
						number-graphic
						@open-applicants="openApplicants"
						@view-summary="viewSummary"
						@view-graphic="viewGraphic"
					/>
				</v-flex>
			</v-layout>
			<modal
				:dialog="dialog"
				:create="false"
				title="Cerrar"
				@close-modal="closeModal"
				@create-employee="closeModal"
			>
				<div class="applicants-table" :style="`border: 1px solid ${$appColors.gray}`">
					<table-modal
						:columns="columns"
						:rows="rows"
						blue
					>
						<template slot="rows" slot-scope="props">
							<td :style="`color:${$appColors.secondary}`">
								{{ props.row.employee ? props.row.employee.name : null }} {{ props.row.employee ? props.row.employee.lastName : null }}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{ setGender(props.row.employee.gender) }}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{ props.row.employee ? props.row.employee.documentNumber : null}}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{  props.row.employee ? props.row.employee.email : null }}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{ props.row.group ? props.row.group.name : null }}
							</td>
						</template>
					</table-modal>
				</div>
			</modal>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>
	</div>
</template>
<script>
import titleHeader from '@/components/diagnosis/title-header';
import cardTool from '@/components/diagnosis/card-tool';
import modal from '@/components/configuration/open-modal';
import tableModal from '@/components/configuration/assign-area';

function created() {
	if (this.$route.name === 'detail-diagnoses') {
		this.loadData();
	}
}

async function openApplicants() {
	this.dialog = true;
	const diagnosisId = this.$route.params.id;
	try {
		const { data: response } = await this.$httpPraktiko.get(`/diagnostic/${diagnosisId}/employees`);
		this.rows = response;
		this.dialog = true;
	} catch (error) {
		this.showGenericError();
	}
}

function closeModal(value) {
	this.dialog = value;
}

function viewSummary(value) {
	const { toolId } = this.$route.params;
	if (value.tool.code === 'WEV') {
		this.goTo('detail-diagnosis-weather', { params: { toolId, idsummary: value.id } });
	} else if (value.tool.code === 'OCI') {
		this.goTo('detail-summary-inventory', { params: { toolId, idsummary: value.id } });
	} else if (value.tool.code === 'ODG') {
		this.goTo(
			'detail-summary-diagnoses',
			{ params: { toolId, id: value.diagnostic.id, detailId: value.id } },
		);
	}
}

function data() {
	return {
		tools: [],
		dialog: false,
		columns: [
			{ id: 1, name: 'NOMBRE DE EMPLEADO', col: 1 },
			{ id: 2, name: 'SEXO', col: 1 },
			{ id: 3, name: 'NRO DE DOC', col: 1 },
			{ id: 4, name: 'CORREO', col: 1 },
			{ id: 5, name: 'ÁREA', col: 1 },
		],
		rows: [],
		diagnostic: {},
	};
}

async function loadData() {
	try {
		const { data: response } = await this.$httpPraktiko.get(`diagnostic-detail/${this.id}`);
		this.tools = response.map((r) => {
			const newTool = { ...r };
			newTool.graphic = [
				{ image: '/static/img/diagnosis/male.svg', number: r.numMale, description: 'Masculino' },
				{ image: '/static/img/diagnosis/female.svg', number: r.numFemale, description: 'Femenino' },
			];
			newTool.value = newTool.percentageResolved || 0;
			return newTool;
		});
		this.diagnostic = this.tools[0].diagnostic || null;
	} catch (error) {
		this.showGenericError();
	}
}

function setGender(value) {
	return value === 1 ? 'Masculino' : 'Femenino';
}

function viewGraphic(value) {
	const { toolId } = this.$route.params;
	this.goTo(
		'detail-summary-graphic-inventory',
		{
			query: {
				back: 'detail-diagnoses',
			},
			params: {
				idsummary: value.id,
				toolId,
			},
		},
	);
}

function goToBack() {
	const { toolId } = this.$route.params;
	this.goTo('diagnoses', { toolId });
}

export default {
	name: 'page-diagnoses-detail',
	data,
	created,
	components: {
		titleHeader,
		cardTool,
		modal,
		tableModal,
	},
	methods: {
		openApplicants,
		closeModal,
		goToBack,
		loadData,
		setGender,
		viewSummary,
		viewGraphic,
	},
	props: {
		id: [Number, String],
	},
	watch: {
		$route(newVal) {
			if (newVal.name === 'detail-diagnoses') {
				this.loadData();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.applicants-table {
	border-radius: 9px !important;
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.02) !important;
	margin-bottom: 65px;
	margin-top: 30px;
	max-height: 500px;
	overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/diagnosis/page-diagnoses-detail.vue